import { Outlet } from "react-router-dom";
import { globalState } from "../../state";
import { PostMatchingSurvey } from "../modals/postMatching";
import { createSignal } from "solid-js";

export function GlobalLayout() {
  return (
    <>
      <Outlet />
      <PostMatchingSurvey
        open={globalState.shouldShowMatchingSurvey}
        onCancel={() => {
          // TODO: submit a counter here so we can tell when people cancel?
          globalState.shouldShowMatchingSurvey.value = false;
        }}
        onComplete={() => {
          // TODO: submit the survey here so we can use contexts?
          globalState.shouldShowMatchingSurvey.value = false;
        }}
      />
    </>
  );
}
